import { safeRound } from '@utils/safeRound'

import { ContentProps, ProductDetailType } from './Content.interface'

const guaranteedAprContent = ({
    creditCard,
}: {
    creditCard: ContentProps['creditCard']
}) => {
    const guaranteedAPR = creditCard.guaranteedRate.guaranteedAPR

    if (guaranteedAPR == null || guaranteedAPR <= 0) {
        return null
    }

    return {
        title: `% APR (${creditCard.isFixedRate ? 'fixed' : 'variable'})`,
        value: `${safeRound(guaranteedAPR, 1)}% APR`,
        detailType: ProductDetailType.GuaranteedExample,
    }
}

export default guaranteedAprContent
